import { render, staticRenderFns } from "./our-idea.en.vue?vue&type=template&id=a6f6d2a8&"
import script from "./our-idea.en.vue?vue&type=script&lang=js&"
export * from "./our-idea.en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports